import React from 'react';

const SuccessMessage: React.FC = () => {
  return (
    <div className="rsvp-card success-card">
      <div className="success-icon">✓</div>
      <h2>Merci !</h2>
      <p>Vos réponses ont été enregistrées avec succès.</p>
    </div>
  );
};

export default SuccessMessage;
